var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamification5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.876,
    height: 32.929,
    viewBox: "0 0 35.876 32.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bavarder",
    transform: "translate(0 -2.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21708",
    "data-name": "Path 21708",
    d: "M9.6,24.661h7.773a.6.6,0,0,0,0-1.2H9.6a.6.6,0,1,0,0,1.2Z",
    transform: "translate(-3.619 -8.443)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21709",
    "data-name": "Path 21709",
    d: "M25.144,29.465H9.6a.6.6,0,0,0,0,1.2H25.144a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-3.619 -10.856)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21710",
    "data-name": "Path 21710",
    d: "M25.144,35.465H9.6a.6.6,0,0,0,0,1.2H25.144a.6.6,0,0,0,0-1.2Z",
    transform: "translate(-3.619 -13.268)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21711",
    "data-name": "Path 21711",
    d: "M32.331,2.507,11.917,2.465A3.55,3.55,0,0,0,8.371,6.011V9.075l-4.825.01A3.55,3.55,0,0,0,0,12.63V25.271a3.549,3.549,0,0,0,3.546,3.545H7.175V34.8a.6.6,0,0,0,1.04.4l5.8-6.383,9.941-.041A3.549,3.549,0,0,0,27.5,25.229v-.068l3.145,3.46a.6.6,0,0,0,1.04-.4V22.24h.64a3.549,3.549,0,0,0,3.546-3.545V6.053A3.55,3.55,0,0,0,32.331,2.507ZM26.309,25.229a2.353,2.353,0,0,1-2.352,2.349L13.75,27.62a.6.6,0,0,0-.44.2L8.371,33.249V28.218a.6.6,0,0,0-.6-.6H3.546A2.352,2.352,0,0,1,1.2,25.271V12.63a2.353,2.353,0,0,1,2.351-2.35l5.422-.011h0l14.989-.031a2.353,2.353,0,0,1,2.35,2.35V25.229Zm8.371-6.535a2.352,2.352,0,0,1-2.35,2.349H31.092a.6.6,0,0,0-.6.6v5.031L27.5,23.383v-10.8a3.55,3.55,0,0,0-3.547-3.546L9.567,9.072V6.01a2.352,2.352,0,0,1,2.349-2.35L32.33,3.7h0a2.353,2.353,0,0,1,2.35,2.35V18.693Z",
    fill: "#7fb1b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamification5);
export default __webpack_public_path__ + "static/media/gamification_5.30ae5425.svg";
export { ForwardRef as ReactComponent };